import { render, staticRenderFns } from "./RegistroPreventa.vue?vue&type=template&id=22d051c1"
import script from "./RegistroPreventa.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroPreventa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RegistroPreventa.vue?vue&type=style&index=0&id=22d051c1&prod&scooped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports